import Plans from './Plans.js';

export default Plans;
